import { Actions, ActionId } from '../../../util/RequestAction';

export const loginThunks = Actions('auth', 'login');
export const logoutThunks = Actions('auth', 'logout');
export const profileThunks = Actions('auth', 'profile');
export const twoFactorThunks = Actions('auth', 'twofactor');

export const loginActionIds = ActionId('auth', 'login');
export const logoutActionIds = ActionId('auth', 'logout');
export const profileActionIds = ActionId('auth', 'profile');
export const twoFactorActionIds = ActionId('auth', 'twofactor');